package com.xtream.composeapp.di

import com.xtream.composeapp.platform.createDataStore
import org.koin.core.module.Module
import org.koin.dsl.module

actual val appModule: Module=module{
    single { createDataStore( null )  }

}